<template>
	<div class="flip-book">
		<div class="pages">
			<template v-for="(page, index) in pages">
				<flip-book-image
					:index="index"
					:page="page"
					:current-page="currentPage"
					:page-count="pageCount"
					:is-mobile="isMobile"
					:key="index"
					:going-forward="goingForward"
					:alone="index === 1 || index === pageCount"
					v-if="page" />
			</template>
		</div>

		<div class="footer">
			<div class="pager">
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn class="page-button" v-on="on" @click="first" :disabled="currentPage <= 0"><v-icon>fast_rewind</v-icon></v-btn>
					</template>
					<span class="tooltip">First page</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn class="page-button" v-on="on" @click="previous" :disabled="currentPage <= 0"><v-icon>skip_previous</v-icon></v-btn>
					</template>
					<span class="tooltip">Previous page</span>
				</v-tooltip>

				{{ pageDisplay }}

				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn class="page-button" v-on="on" @click="next" :disabled="currentPage >= pageCount - 1"><v-icon>skip_next</v-icon></v-btn>
					</template>
					<span class="tooltip">Next page</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn class="page-button" v-on="on" @click="last" :disabled="currentPage >= pageCount - 1"><v-icon>fast_forward</v-icon></v-btn>
					</template>
					<span class="tooltip">Last page</span>
				</v-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
import FlipBookImage from './FlipBookImage';

export default {
	props: {
		digitalBook: null
	},
	data: () => {
		return {
			currentPage: 0,
			isMobile: false,
			goingForward: true
		};
	},
	computed: {
		pageDisplay() {
			if(this.currentPage <= 0) {
				return 'Front Cover';
			} if(this.currentPage <= 1) {
				return 'Inside Front Cover';
			} else if(this.currentPage >= this.pageCount - 1) {
				return 'Back Cover';
			} else if(this.currentPage >= this.pageCount - 2 && this.isMobile) {
				return 'Inside Back Cover';
			} else {
				return 'Page ' + this.visiblePage + ' of ' + this.visiblePageCount;
			}
		},
		visiblePage() {
			if(this.isMobile) {
				return this.currentPage - 1;
			} else {
				return Math.max(1, this.currentPage - 2);
			}
		},
		pages() {
			if(this.isMobile) {
				return this.digitalBook.pages;
			} else {
				return [null, ...this.digitalBook.pages];
			}
		},
		pageCount() {
			return this.digitalBook.pages.length;
		},
		visiblePageCount() {
			return this.pageCount - 4;
		},
		incrementBy() {
			return this.isMobile ? 1 : 2;
		}
	},
	methods: {
		first() {
			this.currentPage = 0;
			this.goingForward = false;
		},
		previous() {
			this.currentPage -= this.incrementBy;
			this.goingForward = false;
		},
		next() {
			this.currentPage += this.incrementBy;
			this.goingForward = true;
		},
		last() {
			this.currentPage = Math.floor(this.pageCount / 2) * 2;
			this.goingForward = true;
		},
		handleWindowResize() {
			// TODO: Page flip animations completely break mobile view
			/*this.isMobile = Math.min(window.innerWidth, window.outerWidth || window.innerWidth) < 980;

			if(!this.isMobile && this.currentPage % 2 === 1) {
				this.currentPage++;
			} else if(this.isMobile && this.currentPage % 2 === 0 && this.currentPage > 0) {
				this.currentPage--;
			}*/
		}
	},
	components: {
		FlipBookImage
	},
	mounted() {
		window.addEventListener('resize', this.handleWindowResize);
		this.handleWindowResize();
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleWindowResize);
	}
};
</script>

<style scoped>
	.flip-book {
		display: flex;
		flex-direction: column;

		width: 100%;
		height: 100%;

		perspective: 140vw;
	}

	.pages {
		flex-grow: 1;
		display: flex;
		min-height: 0;
		justify-content: center;
		align-items: center;
		z-index: 100;
		position: relative;
		margin-top: 1em;
	}

	.footer {
		margin-top: 1em;
		flex-grow: 0;
		flex-shrink: 0;

		display: flex;
		justify-content: center;
	}

	.tooltip {
		z-index: 101;
	}

	.pager {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-grow: 0;
	}

	.v-btn.page-button {
		margin-left: 0.5em;
		margin-right: 0.5em;
		min-width: 48px;
	}
</style>